module.exports = __webpack_public_path__ + "img/limit.00b4eeb0.svg";